import { createMongoAbility, MongoAbility } from '@casl/ability'

export interface Rule {
  action: string
  subject: string
}

export type AppAbility = MongoAbility<[string, string]>

export const ability = createMongoAbility<[string, string]>()
